<template>
    <div class="popup-wrapper">
        <div class="popup-wrapper--container">
            <div class="popup popup-gls">
                <div class="popup--close" @click="$emit('close')">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 5.0625L10 10.0625L5 15.0625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 5.0625L10 10.0625L15 15.0625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div class="popup--header popup-header-flex">
                    <svg viewBox="0 0 66 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <path d="M56.9709 18.2047C58.6318 18.2047 59.9781 19.551 59.9781 21.2118C59.9781 22.8726 58.6318 24.219 56.9709 24.219C55.3101 24.219 53.9639 22.8726 53.9639 21.2118C53.9639 19.551 55.3101 18.2047 56.9709 18.2047Z" fill="#FFD100"/>
                            <path d="M14.7927 14.5316V18.4662H18.0663C17.5881 19.2168 16.5099 19.6164 15.7784 19.6164C13.3143 19.6164 12.0822 18.2118 12.0822 15.378C12.0822 12.2485 13.7086 10.6468 16.9366 10.6468C18.218 10.6468 19.8936 10.9671 21.6924 11.5339V6.82738C21.1749 6.60567 20.3864 6.43315 19.3761 6.26063C18.3411 6.08811 17.4294 6.01423 16.6409 6.01423C13.4375 6.01423 10.8994 6.8767 9.00201 8.60159C7.1046 10.3265 6.14355 12.6427 6.14355 15.5751C6.14355 18.261 6.88283 20.3803 8.36131 21.9326C9.8398 23.5097 11.8358 24.2982 14.3492 24.2982C16.8731 24.2982 19.192 22.9882 19.9393 21.3256L19.9231 24.0025H23.5737V14.5316H14.7927Z" fill="#061AB1"/>
                            <path d="M25.375 24.0026V6.30996H31.0425V19.3946H37.2275V24.0026H25.375Z" fill="#061AB1"/>
                            <path d="M39.0267 23.559V18.7293C39.8645 19.0003 40.8502 19.2221 41.9591 19.4192C43.0679 19.6164 44.0289 19.715 44.8421 19.715C46.222 19.715 46.9367 19.37 46.9367 18.7539C46.9367 18.3596 46.7149 18.1624 45.7046 17.9407L43.7333 17.4972C40.3573 16.7333 38.7803 15.033 38.7803 12.15C38.7803 10.2526 39.4456 8.74942 40.7516 7.6406C42.0577 6.55635 43.8811 6.01423 46.1728 6.01423C47.7498 6.01423 50.1647 6.33464 51.6431 6.70418V11.3122C50.8793 11.1151 49.9675 10.9179 48.8587 10.7454C47.7498 10.5729 46.8874 10.499 46.2466 10.499C45.0392 10.499 44.3493 10.844 44.3493 11.46C44.3493 11.8296 44.6696 12.0761 45.3349 12.2485L47.6266 12.7906C50.9778 13.5792 52.5302 15.3041 52.5302 18.2365C52.5302 20.1092 51.8403 21.5877 50.485 22.6719C49.1298 23.7562 47.2569 24.2982 44.8667 24.2982C42.5997 24.2982 40.3081 23.9779 39.0267 23.559Z" fill="#061AB1"/>
                        </g>
                    </svg>
                    Miesto vyzdvihnutia
                </div>

                <div class="popup--notification" :class="{'notification-successful' : data}">
                    <div class="popup--notification--box">
                        <svg v-if="data" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 13L9.5 17L18 8.5" stroke="#0D7D26" stroke-width="2" stroke-linecap="round"/>
                        </svg>

                        {{ !data ? 'Zvoľte miesto vyzdvihnutia' : 'Miesto zvolené' }}
                    </div>

                    <div v-if="data" class="popup--notification--box" @click="$emit('update', data)">
                        <span class="btn btn-default-transparent">Zavrieť a pokračovať</span>
                    </div>
                </div>

                <div class="popup--body">
                    <gls-dpm id="gls-map"></gls-dpm>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        emits: ['close', 'update'],
        props: {
            onClose: {
                type: Function
            },
            onUpdate: {
                type: Function
            },
            cart: {
                type: Object
            }
        },
        data() {
            return {
                data: null
            }
        },
        mounted() {
            const gls = document.getElementById('gls-map')

            gls.addEventListener('change', ( event ) => {
                this.data = event.detail
            })
        }
    }
</script>